import { createSlice } from "@reduxjs/toolkit";
// import instance from "api/globalaxios";
import { getPlatform, getRealhost, gethost } from "./disputeSlice";
import instance, { instanceDPCGC, instanceHotstar } from "api/globalaxios";
export const initialState = {
  loading: false,
  hasErrors: false,
  cases: [],
  activeCase: {},
};

const casesSlice = createSlice({
  name: "cases",
  initialState,
  reducers: {
    setProgress: (state) => {
      state.loading = true;
    },
    setSucessfull: (state, { payload }) => {
      state.cases = payload.results;
      state.loading = false;
      state.hasErrors = false;
    },
    setError: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
    setSucessfullCase: (state, { payload }) => {
      const index = state.cases.findIndex((cse) => cse.id === payload.id);
      if (index !== -1) {
        state.cases[index] = payload;
      } else {
        state.cases.push(payload);
      }
      state.activeCase = payload;
      state.loading = false;
      state.hasErrors = false;
    },
    setSucessfullGet: (state, { payload }) => {
      state.activeCase = payload;
      state.loading = false;
      state.hasErrors = false;
    },
  },
});

export const {
  setProgress,
  setSucessfull,
  setError,
  setSucessfullCase,
  setSucessfullGet,
} = casesSlice.actions;

export default casesSlice.reducer;

export function getCasesForPagination(pageNo) {
  return async (dispatch) => {
    dispatch(setProgress());
    return await instance({
      method: "get",
      url: `/api/casefile/?page=${pageNo}` + "&host=" + gethost()+ `&platform=${getPlatform()}`,
    }).then(
      (response) => {
        console.log(response.data);
        dispatch(setSucessfull(response.data));
        return response.data;
      },
      (error) => {
        console.log(error);

        dispatch(setError());
      }
    );
  };
}

export function getCases(params = {}) {
  return async (dispatch) => {
    dispatch(setProgress());
    instance({
      method: "get",
      url: "/api/casefile/" + "?host=" + gethost()+ `&platform=${getPlatform()}`,
      params: params,
    }).then(
      (response) => {
        dispatch(setSucessfull(response.data));
        console.log("getcasesswebnyayyyaaaaa", response.data);
        return response.data;
      },
      (error) => {
        console.log(error);
        // console.log(error.request.status);
        // console.log(error.message)
        // console.log(error.request.response)
        dispatch(setError());
      }
    );
  };
}

export function getDPCGCCases(params = {}) {
  return async (dispatch) => {
    dispatch(setProgress());
    instanceDPCGC({
      method: "get",
      url: "/api/casefile/",
      params: {
        ...params,
        platform: getPlatform(),
      },
    }).then(
      (response) => {
        dispatch(setSucessfull(response.data));
        console.log("dpcc casesssssssssssssssssssssssss", response.data);
        return response.data;
      },
      (error) => {
        console.log(error);
        // console.log(error.request.status);
        // console.log(error.message)
        // console.log(error.request.response)
        dispatch(setError());
      }
    );
  };
}

export function getCaseAnonymous(dispute, email, phone) {
  return async (dispatch) => {
    dispatch(setProgress());
    try {
      let response = await instance({
        method: "get",
        url: "/api/casefileanonymous/",
        params: {
          host: gethost(),
          dispute__id: dispute,
          email: email,
          phone,
        },
      });

      dispatch(setSucessfullGet(response.data.results[0]));
      return response.data.results[0];
    } catch (error) {
      console.log(error);
      dispatch(setError());
      throw error;
    }
  };
}

export function getCase(dispute) {
  return async (dispatch) => {
    dispatch(setProgress());
    try {
      let response = await instance({
        method: "get",
        url: "/api/casefile/" + "?host=" + gethost(),
        params: {
          dispute__id: dispute,
          platform: getPlatform(),
        },
      });

      dispatch(setSucessfullGet(response.data.results[0]));
      console.log("getcaseeeeeeeeeeeeewebnyayyaaa", response.data);
      return response.data.results[0];
    } catch (error) {
      console.log(error);
      dispatch(setError());
      throw error;
    }
  };
}

export function getDPCGCCase(dispute) {
  return async (dispatch) => {
    dispatch(setProgress());
    try {
      let response = await instanceDPCGC({
        method: "get",
        url: "/api/casefile/",
        params: {
          dispute__id: dispute,
          platform: getPlatform(),
        },
      });

      dispatch(setSucessfullGet(response.data.results[0]));
      console.log("getdpcgccaseeeeeeeeeeeee", response.data);
      return response.data.results[0];
    } catch (error) {
      console.log(error);
      dispatch(setError());
      throw error;
    }
  };
}

export function updateCaseAnonymous(casePayload, email, phone) {
  console.log("casePayload before:", casePayload);
  if (
    casePayload.proposed_flow &&
    casePayload.proposed_flow === "grievance redressal"
  ) {
    casePayload.proposed_flow = "arbitration";
  }
  console.log("casePayload after:", casePayload);
  return async (dispatch) => {
    dispatch(setProgress());
    try {
      let response = await instance({
        method: "patch",
        url: "/api/casefileanonymous/" + casePayload.id + "/?host=" + gethost(),
        data: casePayload,
        params: {
          email: email,
          phone,
        },
      });
      dispatch(setSucessfullCase(response.data));
      return response.data;
    } catch (error) {
      console.log(error);
      dispatch(setError());
    }
  };
}

export function updateCase(casePayload) {
  console.log("casePayload before:", casePayload);
  if (
    casePayload.proposed_flow &&
    casePayload.proposed_flow === "grievance redressal"
  ) {
    casePayload.proposed_flow = "arbitration";
  }
  console.log("casePayload after:", casePayload);
  return async (dispatch) => {
    dispatch(setProgress());
    try {
      let response = await instance({
        method: "patch",
        url: "/api/casefile/" + casePayload.id + "/" + "?host=" + gethost(),
        data: casePayload,
      });
      dispatch(setSucessfullCase(response.data));
      return response.data;
    } catch (error) {
      console.log(error);
      dispatch(setError());
    }
  };
}

export function createCase(createCaseBody) {
  return async (dispatch) => {
    dispatch(setProgress());
    try {
      let response = await instance({
        method: "post",
        url: "/api/casefile/" + "?host=" + getRealhost(),
        data: createCaseBody,
      });

      // dispatch(setSucessfullCase(response.data));
      dispatch(getCase(createCaseBody.dispute));

      return response.data;
    } catch (error) {
      console.log(error);
      dispatch(setError());
      throw error;
    }
  };
}

export function createCaseAnonymous(createCaseBody, email, phone) {
  return async (dispatch) => {
    dispatch(setProgress());
    try {
      let response = await instance({
        method: "post",
        url: `/api/casefileanonymous/?host=${getRealhost()}`,
        data: createCaseBody,
        params: {
          email: email,
          phone: phone,
        },
      });

      // dispatch(setSucessfullCase(response.data));
      dispatch(getCaseAnonymous(createCaseBody.dispute, email, phone));

      return response.data;
    } catch (error) {
      console.log(error);
      dispatch(setError());
      throw error;
    }
  };
}
export function UpdateCase(CaseBody) {
  return async (dispatch) => {
    dispatch(setProgress());
    try {
      let response = await instance({
        method: "patch",
        url: "/api/casefile/" + CaseBody.id + "?host=" + gethost(),
        data: CaseBody,
      });

      // dispatch(setSucessfullCase(response.data));
      dispatch(getCase(CaseBody.dispute));

      return response.data;
    } catch (error) {
      console.log(error);
      dispatch(setError());
      throw error;
    }
  };
}
